import { fetchData } from "./fetchData";

//get poi group details using JobID
export const getPOIGroupsByJobAPI = async(jobId) => {
    const route = `/pois/groups?jobid=${jobId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//get pois by group
export const getPOIsByGroupAPI = async(poiGroupId) => {
    const route = `/pois/groups/${poiGroupId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//create poi group
export const createPOIGroupAPI = async(poiGroupData) => {
    const route = `/pois/groups`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(poiGroupData)
    }

    let response = await fetchData(route, options);

    return response;
}

//update poi group
//poiId is sent in the body
export const updatePOIGroupAPI = async(poiGroupId, poiGroupData) => {
    const route = `/pois/groups/${poiGroupId}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(poiGroupData)
    }

    let response = await fetchData(route, options);

    return response;
}

//delete poi group
//POIGroupID is sent in the body
export const deletePOIGroupAPI = async(poiGroupId) => {
    const route = `/pois/groups`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({POIGroupID: poiGroupId})
    }

    let response = await fetchData(route, options);

    return response;
}

//add poi(s) to group
//array of objects {POIID: int, POI_Name: string} sent in array
export const addPOIsToGroupAPI = async(poiGroupId, pois) => {
    const route = `/pois/groups/${poiGroupId}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({pois})
    }

    let response = await fetchData(route, options);

    return response;
}

//remove poi(s) from group
export const removePOIsFromGroupAPI = async(poiGroupId, pois, userID) => {
    const data = {
        pois,
        userID
    }
    
    const route = `/pois/groups/${poiGroupId}`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }

    let response = await fetchData(route, options);

    return response;
}


//get all linked pois for a specific poi
export const getLinkedPOIsAPI = async(poiId) => {
    const route = `/pois/linkedpois/${poiId}`;

    const options = {
        method: 'GET',
        
    }

    let response = await fetchData(route, options);

    return response;
}